import React, { Alert, AlertTitle, Button, Grid, TableCell, TableRow } from '@mui/material';
import { TableErrorMessageProps } from './TableErrorMessageProps';

export const TableErrorMessage = (props: TableErrorMessageProps) => {
	return (
		<TableRow>
			<TableCell colSpan={props.colSpan}>
				<Alert severity='error'>
					<AlertTitle>Error</AlertTitle>
					An error has occured. Please refresh the page.
				</Alert>
				<Grid container xs={12} textAlign={'center'}>
					<Grid item xs={12} pt={2}>
						<Button
							color='primary'
							variant='contained'
							onClick={() => {
								window.location.reload();
							}}
						>
							Refresh page
						</Button>
					</Grid>
				</Grid>
			</TableCell>
		</TableRow>
	);
};
